import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Menu, MenuItem, IconButton } from '@mui/material';
import { Facebook, Email, Instagram } from '@mui/icons-material';
import axios from 'axios';

const Header = () => {
  const currentPath = window.location.pathname;

  const [aboutAnchorEl, setAboutAnchorEl] = useState(null);
  const [syllabusAnchorEl, setSyllabusAnchorEl] = useState(null);
  const [timetableAnchorEl, setTimetableAnchorEl] = useState(null);
  const [admissionAnchorEl, setAdmissionAnchorEl] = useState(null);

  const [syllabusData, setSyllabusData] = useState([]);
  const [timetableData, setTimetableData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [syllabusRes, timetableRes] = await Promise.all([
          axios.get('https://backend-school-914b.onrender.com/syllabus'),
          axios.get('https://backend-school-914b.onrender.com/timetable'),
        ]);
        setSyllabusData(syllabusRes.data);
        setTimetableData(timetableRes.data);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
    fetchData();
  }, []);

  const handleDropdownOpen = (setter) => (event) => {
    setter(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAboutAnchorEl(null);
    setSyllabusAnchorEl(null);
    setTimetableAnchorEl(null);
    setAdmissionAnchorEl(null);
  };

  const aboutOptions = [
    { label: 'Education', path: '/education' },
    { label: 'Social Service', path: '/social-service' },
    { label: 'Motivation', path: '/motivation' },
    { label: 'Logo', path: '/logo' },
    { label: 'Future Plan', path: '/future-plan' },
  ];

  const AdmissionOptions = [
    { label: 'Admission Procedure', path: '/admission-procedure' },
    // { label: 'Rules and Regulations', path: '/rules-regulations' },
    { label: 'Admission Enquiry', path: '/admission-enquiry' },

  ];

  const filteredOptions = aboutOptions.filter((option) => option.path);
  const filteredAdmissionOptions = AdmissionOptions.filter((option) => option.path );

  return (
    <>
    <AppBar
      position="static"
      sx={{
        backgroundColor: '#fff',
        
        padding: 2,
      }}
    >
   <Toolbar
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'nowrap', // Allow wrapping for smaller screens
  }}
>
  {/* Logo and Name/Title Section */}
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      justifyContent: 'center', // Center the logo and text
      flexDirection: { xs: 'column', md: 'row' }, // Column on small screens, row on medium+
      textAlign: { xs: 'center', md: 'left' }, // Center text on small screens
      width: '100%', // Ensure the section takes the full width
      marginBottom: { xs: 2, md: 0 }, // Add margin below on small screens to avoid cramping
marginLeft:'10%'   
    }}
  >
    <Box>
      <img
        src="Images/LOGO.png"
        alt="Logo"
        style={{ width: '80px', height: '80px' }}
        
      />
    </Box>
    <Box>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          fontFamily: 'Roboto Slab, serif',
          fontSize: '2.6    rem',
          marginBottom: '-10px',
          color: '#000',
        }}
      >
        JAMIA NIDA-E-ISLAM
      </Typography>
      {/* <Typography
        variant="body2"
        sx={{
          fontStyle: 'italic',
          color: 'white',
          fontSize: '1rem',
          marginTop: '-10px',
        }}
      >
        Knowledge is Light
      </Typography> */}
    </Box>
  </Box>

  {/* Social Media Buttons */}
  <Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end', // Right align the social media buttons
    width: { xs: '100%', md: 'auto' }, // Full width on small screens

  }}
>
  <IconButton
    href="https://www.facebook.com/profile.php?id=61570443219086&mibextid=ZbWKwL"
    target="_blank"
    rel="noopener noreferrer"
    sx={{ color: '#4267B2' }} // Facebook blue color
  >
    <Facebook />
  </IconButton>
  <IconButton
    href="mailto:jniinst786@gmail.com"
    target="_blank"
    rel="noopener noreferrer"
    sx={{ color: '#1DA1F2' }} // Twitter blue color
  >
    <Email />
  </IconButton>
  <IconButton
    href="https://www.instagram.com/jamia_nida_e_islam_school?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
    target="_blank"
    rel="noopener noreferrer"
    sx={{ color: '#E1306C' }} // Instagram pink color
  >
    <Instagram />
  </IconButton>
</Box>
</Toolbar>
    </AppBar>

        {/* Button Row */}
        <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: 1,
          backgroundColor:'rgb(252, 184, 210)',
          borderRadius: '0 0 20px 20px',
          
        }}
      >
          <Button sx={{ color: '#000' }} href="/">
            Home
          </Button>
          <Button sx={{ color: '#000' }} href="/gallery">
            Gallery
          </Button>

        <Button sx={{ color: '#000' }} onClick={handleDropdownOpen(setAboutAnchorEl)}>
          About Us
        </Button>
        <Menu anchorEl={aboutAnchorEl} open={Boolean(aboutAnchorEl)} onClose={handleDropdownClose}>
          {filteredOptions.map((option) => (
            <MenuItem
              key={option.path}
              onClick={() => {
                window.location.href = option.path;
                handleDropdownClose();
              }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Menu>
        <Button sx={{ color: '#000'}} onClick={handleDropdownOpen(setAdmissionAnchorEl)}>
          Admission
        </Button>
        <Menu anchorEl={admissionAnchorEl} open={Boolean(admissionAnchorEl)} onClose={handleDropdownClose}>
          {filteredAdmissionOptions.map((option) => (
            <MenuItem
              key={option.path}
              onClick={() => {
                window.location.href = option.path;
                handleDropdownClose();
              }}
            >
              {option.label}
            </MenuItem>
          ))}
        </Menu>
        {/* <Button sx={{ color: '#fff' }} onClick={handleDropdownOpen(setSyllabusAnchorEl)}>
          Syllabus
        </Button>
        <Menu anchorEl={syllabusAnchorEl} open={Boolean(syllabusAnchorEl)} onClose={handleDropdownClose}>
          {syllabusData.map((item) => (
            <MenuItem
              key={item._id}
              onClick={() => {
                window.location.href = item.downloadLink;
                handleDropdownClose();
              }}
            >
              {item.class}
            </MenuItem>
          ))}
        </Menu>
        <Button sx={{ color: '#fff' }} onClick={handleDropdownOpen(setTimetableAnchorEl)}>
          TimeTable
        </Button>
        <Menu anchorEl={timetableAnchorEl} open={Boolean(timetableAnchorEl)} onClose={handleDropdownClose}>
          {timetableData.map((item) => (
            <MenuItem
              key={item._id}
              onClick={() => {
                window.location.href = item.downloadLink;
                handleDropdownClose();
              }}
            >
              {item.class}
            </MenuItem>
          ))}
        </Menu> */}
                  <Button sx={{ color: '#000' }} href="/academics">
            Academics
          </Button>

          <Button sx={{ color: '#000'}} href="/contact">
            Contact Us
          </Button>


          <Button sx={{ color: '#000' }} href="/donate">
            Donate Us
          </Button>

      </Box>
    </>
  );
};

export default Header;
